
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/special/resident-internal-medicine",
      function () {
        return require("private-next-pages/special/resident-internal-medicine/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/special/resident-internal-medicine"])
      });
    }
  